// @flow
import { setupRequest } from "./request.reducer";
import { RequestState } from "../records/request.record";
import { Correction } from "../records/post.record";
import {
    closeCorrection,
    editCorrection,
    newCorrection,
    submitCorrection,
    submitCorrectionFailure,
    submitCorrectionSuccess,
    updateCorrection
} from "../actions/correction.actions";
import { handleActions } from "redux-actions";
import Record from "../flow/Record";

const createRequest = setupRequest("createRequest");

class CreateEditCorrection extends Record({
    createRequest: new RequestState(),
    correction: new Correction(),
    open: false
}) {
    createRequest: RequestState;
    correction: Correction;
    open: boolean;
}

const createEditCorrection = handleActions(
    {
        [newCorrection](state, { payload: { post } }) {
            const correction = new Correction({
                postId: post.id,
                body: post.body
            });
            return state.merge({
                correction,
                open: true
            });
        },
        [editCorrection](state, { payload: { correction } }) {
            return state.merge({
                open: true,
                correction
            });
        },
        [closeCorrection](state) {
            return state.set("open", false);
        },
        [updateCorrection](state, { payload: { correction } }) {
            return state.set("correction", state.correction.merge(correction));
        },
        [submitCorrection]: createRequest.start,
        [submitCorrectionSuccess](state) {
            return createRequest.success(state).set("open", false);
        },
        [submitCorrectionFailure]: createRequest.failure
    },
    new CreateEditCorrection()
);

export default createEditCorrection;



// WEBPACK FOOTER //
// ./src/reducers/createEditCorrection.reducer.js